<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import { clearSession } from '../../session';
    import Fa from 'svelte-fa'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn,faCircleNotch,faArrowsRotate,faRightFromBracket,faVolumeHigh, faUser,faCircleUser} from '@fortawesome/free-solid-svg-icons';
    import Marquee from 'svelte-fast-marquee';
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    let myLink = dataSetting.homepage
    let balance = 0.00
    let acc_name =""
    let loaDing = false
    let txtTitle = ''
     let objs
    if(dataSetting.other){
        objs = JSON.parse(dataSetting.other)
        if(objs.textslide==''){
            txtTitle = ' ยินดีต้อนรับสู่ '+dataSetting.title+'     '
        }else{
            txtTitle = objs.textslide
        }
        
    }
    async function getBalance() {
        loaDing = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            loaDing = true
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
		} else {
            clearSession();
            push('/')
            throw new Error(json);
		}
    }
    async function Logout() {
        // loading = true
                clearSession();
                push('/auth');
    }
    let ufabetset =false;
    let isOnlyUFAF =false;
    let platformListF =[];
    let device = 'desktop' 
    async function getPlatformF() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformListF = json.payload
            let dataPL = []
            
            // dataPL = JSON.parse(dataSetting.platform)
            if(dataSetting.platform!=""){
                dataPL = JSON.parse(dataSetting.platform)
            }
            for await (let abs of platformListF) {
                var xx= 0;
                for await (let val2 of dataPL) {
                    if(abs._id==val2){
                        xx=xx+1
                        break;
                    }
                }
                if(xx>0){
                    if(abs.platform_prefix=='UFA'){
                        ufabetset = true
                    }
                }
                
            }
            if(ufabetset==true&&dataPL.length==1){isOnlyUFAF=true}
		} else {

            throw new Error(json);
		}
    }
    getPlatformF()
    getBalance()
   
</script>
<div class="headers">
    <div class="blog-6">
        <a href="javascript:;"  on:click={() => push('/dashboard')}><img src="{dataSetting.logo}" alt="" style="max-width: 100%; max-height: 30px;"></a>
    </div>
    <div class="blog-6 last">
       <div class="blog-credit">
        {#if isOnlyUFAF==false}
            <div class="a">เครดิต &nbsp;&nbsp;</div>
            <div class="b">
            {#if loaDing}
            {balance}
            {:else}
            <Fa icon={faCircleNotch} size="sm" class="text-white" spin/>  
            {/if}
            </div>
            <div class="c">
                 <button type="button" on:click={() => getBalance()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faArrowsRotate} size="md"    style="color:#fff; cursor:pointer;" /></button>
            </div>
            <div class="d">
                 <button type="button" on:click={() => Logout()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faRightFromBracket} size="md"    style="color:#ee264f; cursor:pointer;" /></button>
            </div>
        {:else}
            <div>
                <a href="javascript:;" on:click={() => push('/setting')}  style="color: #FFF;background: transparent; padding: 0;">
                   <Fa icon={faCircleUser} size="md"/>&nbsp;{acc_name}
                </a>
            </div>
            <div class="c">&nbsp;</div>
            <div class="d">
                 <button type="button" on:click={() => Logout()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faRightFromBracket} size="md"    style="color:#ee264f; cursor:pointer;" /></button>
            </div>
        {/if}
            
       </div>
    </div>
</div>
<div class="blog-slid">
    <div class="fds" >
        <Fa icon={faVolumeHigh} size="md"/>
    </div>
    <Marquee pauseOnHover={false} speed={40} play={true} >{txtTitle}</Marquee>
</div>
<!-- <div class="headers">
    <div class="blog-6">
        <a href={myLink}><img src="{dataSetting.logo_wallet}" alt="" style="max-width: 100%; "></a>
    </div>
    <div class="blog-6 last">
       <a href="">เข้าสู่ระบบ</a>
       <a href="">สมัครสมาชิก</a>
    </div>
</div> -->
<style>
@media only screen and (max-width: 767px) {
    :global(.themes.default .default-home .blog-slid .fds){
       font-size: 16px !important;
    }
    :global(.themes.default .blog-slid .marquee){
       font-size: 16px;
    }
}
/* ให้แถบ header ติดด้านบนเมื่อ scroll (ใต้ PWA banner พอดี) */
.headers{
    position: sticky;
    position: -webkit-sticky;
    top: var(--pwa-banner-h, 0px);
    z-index: 1000;
}
</style>
